import * as React from "react";

import { ContentCategoryRow } from "../../common/contentTypes";
import { groupCategories } from "./categoryGroups";
import { SearchableSelect } from "./SearchableSelect";

interface Props {
  categories: ContentCategoryRow[];
  /** Selected category id, or "" for none. */
  value: string;
  onChange: (categoryId: string) => void;
  /** Label for the unfiltered choice. Omit in the editor, where one is required. */
  emptyOption?: string;
  placeholder?: string;
  id?: string;
}

/**
 * The category picker used by both the Questions filter and the editor.
 *
 * The menu shows bare names under their group heading; the closed control shows
 * `Group:Name`, which is how a category reads everywhere else in this tool.
 * Search runs against that full form, so typing either half finds it.
 */
export const CategorySelect: React.FC<Props> = ({
  categories,
  value,
  onChange,
  emptyOption,
  placeholder,
  id,
}) => (
  <SearchableSelect
    id={id}
    value={value}
    onChange={onChange}
    emptyOption={emptyOption}
    placeholder={placeholder}
    options={groupCategories(categories).map((group) => ({
      label: group.group,
      options: group.categories.map((category) => {
        const emoji = category.emoji ? `${category.emoji} ` : "";
        return {
          value: category.id,
          label: `${emoji}${category.group}:${category.name}`,
          menuLabel: `${emoji}${category.name}`,
        };
      }),
    }))}
  />
);
